/* eslint-disable @typescript-eslint/no-explicit-any */
import { Observable } from 'rxjs';

import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { CORE_CONFIG } from '../config/core-config';
import { QueryConfig } from './api.model';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private http = inject(HttpClient);
  private apiBaseUrl = inject(CORE_CONFIG).apiBaseUrl;

  get<T>(url: string, config?: QueryConfig): Observable<T> {
    let params: HttpParams = new HttpParams();

    if (config) {
      Object.entries(config).forEach(([key, value]) => {
        params = params.set(key, JSON.stringify(value));
      });
    }

    return this.http.get<T>(`${this.apiBaseUrl}${url}`, { params });
  }

  post<T>(url: string, data: Partial<T>, options?: { context?: HttpContext }): Observable<any> {
    return this.http.post<T>(`${this.apiBaseUrl}${url}`, data, options);
  }

  put<T>(url: string, data: Partial<T>): Observable<any> {
    return this.http.put<T>(`${this.apiBaseUrl}${url}`, data);
  }

  delete<T>(url: string): Observable<unknown> {
    return this.http.delete<T>(`${this.apiBaseUrl}${url}`);
  }
}
